// extracted by mini-css-extract-plugin
export default {"page":"CourseReturnPage_page__0691j","title":"CourseReturnPage_title__YdwpW","message":"CourseReturnPage_message__ene6J","backButton":"CourseReturnPage_backButton__kNG8s"};